module.exports = __webpack_public_path__ + "static/media/horizon.71662cad.png";